export const BASE_PATH_TO_CLAN = "/dashboard";

export const BASE_PATH_TO_CLANS_LIST = `${BASE_PATH_TO_CLAN}/clans-list`
export const BASE_PATH_TO_CLAN_CHATS_LIST = `${BASE_PATH_TO_CLAN}/clan-chats-list`